import React from "react";
import "./header.scss";

import logo from "../../img/napkon_logo.png";
import Menu from "../menu/menu.js";

function Header() {
  return (
    <div>
      <header className="appBar">
        <div className="wrapper">
          <img src={logo} alt="Logo" className="headerLogo" />
          <div className="innerWrapper">
            <Menu />
            <a href="https://account.napkon.de/auth/realms/users/account">
              Einstellungen
            </a>
          </div>
          <a href="https://account.napkon.de/auth/realms/users/protocol/openid-connect/logout?redirect_uri=https%3A%2F%2Faccount.napkon.de%2Fauth%2Frealms%2Fusers%2Faccount%2F">
            Logout
          </a>
        </div>
      </header>
    </div>
  );
}

export default Header;
